export { renderTag_unstable as renderTag } from '@fluentui/react-tags';
